import type { CSSObject } from '@emotion/react';

export const containerStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  minWidth: 0,
  paddingRight: 'var(--fabric-space-gap-xxs)',
  gap: 'var(--fabric-space-gap-xs)',
};

export const namingWrapperStyles: CSSObject = {
  display: 'flex',
  alignItems: 'baseline',
  minWidth: 0,
};

export const visibleNamesTitleStyles: CSSObject = {
  minWidth: 0,
  paddingRight: 0,
};

export const hiddenNamesTitleStyles: CSSObject = {
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export const compactModeStyles: CSSObject = {
  fontSize: 'var(--fabric-font-size-md)',
};

export const editInputStyles: CSSObject = {
  fontSize: 'var(--fabric-font-size-lg)',
  fontWeight: 'var(--fabric-font-weight-normal)',
  lineHeight: 1,
  color: 'var(--fabric-color-neutral-100)',
  border: 'var(--fabric-number-n-0-25-px) solid var(--fabric-color-neutral-20)',
  borderRadius: 'var(--fabric-radius-sm)',
  padding: 'var(--fabric-number-n-0-5-px) var(--fabric-number-n-1-5-px)',
  minWidth: 0,
  width: '100%',
  backgroundColor: 'var(--fabric-color-neutral-0)',
  '&:focus-visible': {
    outline: 'none',
    borderColor: 'var(--fabric-color-primary-50)',
  },
};

export const editInputBoldStyles: CSSObject = {
  fontWeight: 'var(--fabric-font-weight-bold)',
};

export const editButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'baseline',
  minWidth: 0,
  maxWidth: '100%',
  borderRadius: 'var(--fabric-radius-sm)',
  '&:hover': {
    backgroundColor: 'var(--fabric-color-neutral-5)',
  },
  '&:focus-visible': {
    outline: 'var(--fabric-number-n-0-25-px) solid var(--fabric-color-primary-50)',
    outlineOffset: 'var(--fabric-number-n-0-25-px)',
  },
};

export const editTitleTriggerStyles: CSSObject = {
  display: 'flex',
  minWidth: 0,
  maxWidth: '100%',
  overflow: 'hidden',
};

export const contactsPaneButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'var(--fabric-number-n-0-5-px)',
  color: 'var(--fabric-color-neutral-70)',
};

export const tooltipContentStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--fabric-number-n-0-5-px)',
};
